// features/organisation/organisationSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { UserOrganisation } from '../../types/types';

interface OrganisationState {
  selected?: UserOrganisation;
}

const loadFromStorage = (): UserOrganisation | undefined => {
  try {
    const stored = localStorage.getItem('selectedOrganisation');
    return stored ? JSON.parse(stored) : undefined;
  } catch {
    return undefined;
  }
};

const initialState: OrganisationState = {
  selected: loadFromStorage(),
};

const organisationSlice = createSlice({
  name: 'organisation',
  initialState,
  reducers: {
    setSelectedOrganisation(
      state,
      action: PayloadAction<UserOrganisation | undefined>
    ) {
      state.selected = action.payload;
      if (action.payload) {
        localStorage.setItem(
          'selectedOrganisation',
          JSON.stringify(action.payload)
        );
      } else {
        localStorage.removeItem('selectedOrganisation');
      }
    },
    clearSelectedOrganisation(state) {
      state.selected = undefined;
      localStorage.removeItem('selectedOrganisation');
    },
  },
});

export const { setSelectedOrganisation, clearSelectedOrganisation } =
  organisationSlice.actions;

export default organisationSlice.reducer;
